import { render, staticRenderFns } from "./ProfilePictureDialog.vue?vue&type=template&id=a2677d6c&scoped=true&"
import script from "./ProfilePictureDialog.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePictureDialog.vue?vue&type=style&index=0&id=a2677d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2677d6c",
  null
  
)

export default component.exports